module.exports = __webpack_public_path__ + "img/dyp01.5939030b.jpg";